import { graphql, Link } from "gatsby"
import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap"
import Layout from "../components/Layout"
import Img from "gatsby-image"
import { useFlexSearch } from "react-use-flexsearch";
import * as queryString from "query-string";
// import RenderTags from "../components/RenderTags";
import kebabCase from "lodash/kebabCase"
import SEO from "../components/SEO";

const SearchNews = ({ news, localSearchNews, location }) => {
    const { search } = queryString.parse(location.search)
    const [query, setQuery] = useState(search || "")

    const results = useFlexSearch(
        query, 
        localSearchNews.index, 
        localSearchNews.store
    )

    function disableSearchButton () {
        document.querySelector(".app-section-news .app-news-detail-search .app-news-detail-icon-close").style.display = "block";
        var check = document.querySelector(".app-section-news .app-news-detail-search .app-news-detail-search-input");
        if (check.value.length === 0) {
            document.querySelector(".app-section-news .app-news-detail-search .app-news-detail-search-btn").style.display = "block";
            document.querySelector(".app-section-news .app-news-detail-search .app-news-detail-icon-close").style.display = "none";
        } else {
            document.querySelector(".app-section-news .app-news-detail-search .app-news-detail-search-btn").style.display = "none";
        }
    }

    function clearDataSearch() {
        document.querySelector(".app-section-news .app-news-detail-search .app-news-detail-search-input").value = "";
        document.querySelector(".app-section-news .app-news-detail-search .app-news-detail-search-btn").style.display = "block";
        document.querySelector(".app-section-news .app-news-detail-search .app-news-detail-icon-close").style.display = "none";
    }
  
    return (
      <>
        <div className="app-news-detail-search">
            <div className="app-news-detail-search-box">
                <input 
                    id="search"
                    className="app-news-detail-search-input" 
                    placeholder="Ask a question" 
                    value={query}
                    onChange={e => {
                        setQuery(e.target.value)
                        disableSearchButton()
                    }}
                />
                <input className="app-news-detail-search-btn" type="button" value="Search" />
                <img className="app-news-detail-icon-search" src="/app-icon-search.svg" alt="app icon search"/>
                <input 
                    className="app-news-detail-icon-close" 
                    type="button" 
                    onClick={e => {
                        setQuery(e.target.value)
                        clearDataSearch()
                    }}
                />
            </div>
            {query ? (
                results.length > 0 ? (
                    <div className="app-news-search-results">
                        <h6>Showing {results.length} results</h6>
                        <NewsKeyworkSearch results={results} />
                        {/* <h6 className="app-news-detail-keyword-search-show-more">
                            Show more
                        </h6> */}
                    </div>
                ) : (
                    <h6 className="app-news-detail-keyword-search-no-results">
                        Sorry, couldn't find any posts matching this
                        search.
                    </h6>
                )
            ) : (
                <NewsAllPost news={news} />
            )}
        </div>
       </>
    )
}

const NewsKeyworkSearch = ({ results }) => 
    results.map(node => {
        const title = node.title || node.slug
        const publishedAt = node.publishedAt
        const description = node.description
        debugger;
        return (
            <div className="app-news-detail-keyword-search" key={node.id}>
                <Row className="app-news-detail-keyword-search-row-custom">
                    {/* <Col xs={12} md={5} lg={5} xl={3} className="app-news-detail-keyword-search-col-custom">
                        <div className="app-news-detail-keyword-search-left">
                            <Link to={"/news/" + node.slug}>
                                <img src={ thumb.childImageSharp.fluid.src } alt="news detail topic search img" />
                            </Link>
                        </div>
                    </Col> */}
                    <Col xs={12} md={7} lg={7} xl={12} className="app-news-detail-keyword-search-col-custom">
                        <div className="app-news-detail-keyword-search-right">
                            <Link to={"/news/" + node.slug}>
                                {title}
                            </Link>
                            <h6>{description}</h6>
                            <div className="app-news-keyword-search-infor-author-calendar-related-article">
                                <div className="app-news-keyword-search-infor-author-calendar">
                                    {/* <div className="app-news-keyword-search-right-author">
                                        <img src="/app-icon-user.svg" alt="app icon user"/>
                                        <h6>{author}</h6>
                                    </div> */}
                                    <div className="app-news-keyword-search-right-calendar">
                                        <img src="/app-icon-calendar.svg" alt="app icon calendar"/>
                                        <h6>{publishedAt}</h6>
                                    </div>
                                </div>
                                {/* <div className="app-news-keyword-search-related-article">
                                    <img src="/app-news-topic-search-right-tag.svg" alt="app news topic search right tag" />
                                    <div className="app-news-keyword-search-related-article-tag">
                                        {(tags).map((res) => (
                                            <Link className="app-news-keyword-search-related-article-link" to={`/tags/${kebabCase(res)}/`} key={res}>{res}</Link>
                                        ))}
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
)

const NewsAllPost = ({ news }) => {
    return (
        <div className="app-news-detail-all-posts">
            <Row>
                {news.map((res) => (
                    <Col xs={12} md={12} lg={12} key={res.id}>
                        <div className="app-news-detail-post-content">
                            {/* <Link to={"/news/" + res.frontmatter.slug}>
                                <Img
                                    fluid={
                                        res.frontmatter
                                            .thumb
                                            .childImageSharp
                                            .fluid
                                    }
                                />
                            </Link> */}
                            <div className="app-news-detail-post-content-description">
                                <Link to={"/news/" + res.frontmatter.slug}>
                                    <div className="app-news-detail-post-content-author-calendar">
                                        {/* <div className="app-news-detail-post-content-author">
                                            <img src="/app-icon-user.svg" alt="app icon user"/>
                                            <h6>{res.frontmatter.author}</h6>
                                        </div> */}
                                        <div className="app-news-detail-post-content-calendar">
                                            {/* <img src="/app-icon-calendar.svg" alt="app icon calendar"/> */}
                                            <h6>{res.frontmatter.author}, {res.frontmatter.publishedAt}</h6>
                                        </div>
                                    </div>
                                    <div className="app-news-detail-post-content-title">{res.frontmatter.title}</div>
                                    <h6>{res.frontmatter.description}</h6>
                                </Link>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>
            {/* <div className="app-news-detail-post-banner">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
                tempor incididunt ut labore et dolore. Ed do eiusmod tempor incididunt ut 
                labore et dolore.
            </div> */}
        </div>
    )
}

class News extends React.Component {
    render() {
        const { data, location } = this.props;
        const localSearchNews = data.localSearchNews;
        const localSearchNewsvi = data.localSearchNewsvi;
        const { html } = data.markdownRemark;
        const news_introduction_vi = data.news_introduction_vi.nodes;
        const news = data.allMarkdownRemark.nodes;
        const news_vi = data.news_all_posts_vi.nodes;
        const { group } = data.allMarkdownRemark;
        const group_vi = data.news_all_posts_vi.group_vi;

        return (
            <Layout>
                <SEO title="News" description="Appvity News for everyone to get more infomation about eProducts and Microsoft. News are created from the Appvity team engineer for best precision and useful tips/hints for users." meta={[{ name: `keywords`, content: ["Appvity News", "tips for eProducts", "tips for eTask", "tips for eHelpdesk"]}]} pathname="/news" />
                <div className="main-content-padding">
                    <div className="app-general-seciton app-section-news-introduction" data-sal="fade" data-sal-duration="1000" data-sal-delay="100" data-sal-easing="ease">
                        <Container>
                            <Row>
                                <Col xs={12} md={12} lg={5}>
                                    <div 
                                        className="app-data-en app-section-news-introduction-detail" 
                                        dangerouslySetInnerHTML={{ __html: html }}
                                    />
                                    {news_introduction_vi.map((res) => (
                                        <div className="app-data-vi app-section-news-introduction-detail" key={res.id} dangerouslySetInnerHTML={{ __html: res.html }} />
                                    ))}
                                </Col>
                                <Col xs={12} md={12} lg={7}></Col>
                            </Row>
                        </Container>
                    </div>
                    <div className="app-general-seciton app-section-news" data-sal="fade" data-sal-duration="1000" data-sal-delay="100" data-sal-easing="ease">
                        <Container>
                            <Row>
                                <Col xs={12} md={12} lg={1}></Col>
                                {/* <Col xs={12} md={12} lg={9}> */}
                                <Col xs={12} md={12} lg={10}>
                                    <div className="app-data-en">
                                        <SearchNews 
                                            localSearchNews={localSearchNews}
                                            location={location}
                                            news={news}
                                        />
                                    </div>
                                    <div className="app-data-vi">
                                        <SearchNews 
                                            localSearchNews={localSearchNewsvi}
                                            location={location}
                                            news={news_vi}
                                        />
                                    </div>
                                </Col>
                                {/* <Col xs={12} md={12} lg={2}>
                                    <div className="app-data-en">
                                        <RenderTags group={group} />
                                    </div>
                                    <div className="app-data-vi">
                                        <RenderTags group={group_vi} />
                                    </div>
                                </Col> */}
                                <Col xs={12} md={12} lg={1}></Col>
                            </Row>
                        </Container>
                    </div>
                    {/* <div className="banner-page">
                        <Container>
                            <h1>News</h1>
                            <h2>Main content news</h2>
                        </Container>
                    </div> */}
                    {/* <div className="news-list">
                        <Container>
                            <Row>
                                {news.map((res) => (
                                    <Col xs={12} md={4}>
                                        <div className="news-item">
                                            <div className="thumb">
                                                <Link
                                                    to={
                                                        "/news/" +
                                                        res.frontmatter.slug
                                                    }
                                                    key={res.id}
                                                >
                                                    <Img
                                                        fluid={
                                                            res.frontmatter
                                                                .thumb
                                                                .childImageSharp
                                                                .fluid
                                                        }
                                                    />
                                                </Link>
                                            </div>
                                            <h3>
                                                <Link
                                                    to={
                                                        "/news/" +
                                                        res.frontmatter.slug
                                                    }
                                                    key={res.id}
                                                >
                                                    {res.frontmatter.title}
                                                </Link>
                                            </h3>
                                            <h4>{res.frontmatter.subTitle}</h4>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Container>
                    </div> */}
                </div>
            </Layout>
        )
    }
}

export default News

export const query = graphql`
    query NewsPage {
        allMarkdownRemark(
            filter: { frontmatter: { directory: { eq: "news_all_posts" } }, fields: { draft: { eq: false } } }
            sort: { fields: frontmatter___publishedAt, order: DESC }
        ) {
            nodes {
                html
                frontmatter {
                    title
                    slug
                    publishedAt(formatString: "MMM DD, yyyy")
                    description
                    author
                }
                id
            }
            group(field: frontmatter___tags) {
                fieldValue
                totalCount
            }
        }
        news_all_posts_vi: allMarkdownRemark(
            filter: { frontmatter: { directory: { eq: "news_all_posts_vi" } }, fields: { draft: { eq: false } } }
            sort: { fields: frontmatter___publishedAt, order: DESC }
        ) {
            nodes {
                html
                frontmatter {
                    title
                    slug
                    publishedAt(formatString: "MMM DD, yyyy")
                    description
                    author
                }
                id
            }
            group_vi: group(field: frontmatter___tags) {
                fieldValue
                totalCount
            }
        }
        markdownRemark(
            frontmatter: { directory: { eq: "news_introduction" } }
        ) {
            html
            id
        }
        news_introduction_vi: allMarkdownRemark(
            filter: { frontmatter: { directory: { eq: "news_introduction_vi" } } }
        ) {
            nodes {
                html
                id
            }
        }
        localSearchNews {
            index
            store
        }
        localSearchNews {
            publicIndexURL
            publicStoreURL
        }
        localSearchNewsvi {
            index
            store
        }
        localSearchNewsvi {
            publicIndexURL
            publicStoreURL
        }
    }
`
